var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHero(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 166,
    height: 215,
    viewBox: "0 0 166 215",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.6398 147.855C75.1059 149.608 90.2184 160.697 91.5032 179.648C92.0367 187.542 89.9843 193.976 88.2967 197.912C86.8377 197.902 84.9051 198.157 83.0705 199.279C79.2216 201.631 77.3434 206.862 78.2798 212.508C96.8437 213.036 115.413 213.564 133.977 214.086C139.143 204.87 135.496 193.323 126.753 188.914C118.794 184.896 108.456 187.727 103.376 195.838C105.14 191.919 108.799 182.354 106.877 170.252C104.22 153.539 92.826 144.001 89.9625 141.736C84.1919 143.778 78.4159 145.814 72.6453 147.855H72.6398Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.7541 132.226C68.6377 148.373 62.1213 162.059 51.8213 166.06C49.6981 166.882 45.2395 168.145 38.7775 166.463C38.6523 164.019 37.9228 162.25 37.4111 161.237C36.9701 160.366 34.8198 156.142 31.3737 155.858C31.3737 155.858 29.9256 155.826 28.287 156.626C20.4314 160.491 22.0428 200.728 22.6035 212.144H54.0751C56.2962 205.589 54.6957 199.182 50.5801 196.405C48.495 195.001 46.1432 194.783 44.4175 194.875C43.2307 190.433 42.0439 185.985 40.8571 181.543C45.5607 181.619 55.5613 181.069 65.0338 174.558C85.2745 160.644 83.0044 133.277 82.89 132.128C77.5114 132.161 72.1327 132.193 66.7595 132.226H66.7541Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0149 149.975L77.8703 159.399L60.8198 158.92L66.2801 148.244L83.0149 149.975Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.3545 152.806L88.1508 165.566L76.5933 145.288L90.9 142.092L99.3545 152.806Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M106.209 138.525C112.045 140.066 124.011 144.171 133.227 155.336C136.107 158.826 138.154 162.316 139.618 165.419C134.441 172.028 134.082 178.609 136.472 180.504C138.459 182.077 142.874 180.836 146.946 177.94C154.813 180.177 161.705 179.617 164.16 176.007C164.895 174.924 166.871 171.157 159.87 159.632C154.339 150.529 141.981 134.562 113.057 118.753",
    fill: "#5B5BD8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M106.209 138.525C112.045 140.066 124.011 144.171 133.227 155.336C136.107 158.826 138.154 162.316 139.618 165.419C134.441 172.028 134.082 178.609 136.472 180.504C138.459 182.077 142.874 180.836 146.946 177.94C154.813 180.177 161.705 179.617 164.16 176.007C164.895 174.924 166.871 171.157 159.87 159.632C154.339 150.529 141.981 134.562 113.057 118.753",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M152.325 173.34C155.858 178.887 156.756 184.652 155.199 187.189C154.497 188.333 153.305 188.801 152.254 188.621C149.494 188.153 146.63 183.03 145.748 175.73",
    fill: "#5B5BD8"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M152.325 173.34C155.858 178.887 156.756 184.652 155.199 187.189C154.497 188.333 153.305 188.801 152.254 188.621C149.494 188.153 146.63 183.03 145.748 175.73",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M158.541 170.939C159.036 171.745 159.559 172.719 160.027 173.857C160.642 175.365 160.996 176.748 161.208 177.886",
    fill: "#5B5BD8"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M158.541 170.939C159.036 171.745 159.559 172.719 160.027 173.857C160.642 175.365 160.996 176.748 161.208 177.886",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4194 194.881C43.2762 195.147 41.7846 195.627 40.1949 196.53C39.2477 197.069 38.4637 197.646 37.8322 198.18L41.7682 184.951L44.4194 194.875V194.881Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6685 142.101C25.5789 142.101 19.8316 136.354 19.8316 129.264C19.8316 122.175 25.5789 116.427 32.6685 116.427C39.7581 116.427 45.5054 122.175 45.5054 129.264C45.5054 136.354 39.7581 142.101 32.6685 142.101Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0224 71.4717C83.5835 71.7221 81.1446 71.9671 78.7057 72.2175C77.5353 64.3183 68.5473 6.54688 46.4012 1.52754C45.0783 1.22812 42.9116 0.770828 40.6632 1.7453C26.4382 7.91876 36.9232 59.1139 39.4547 70.9055C25.725 96.7644 27.9298 125.187 43.3798 140.185C56.0534 152.483 74.7697 152.962 78.9997 153.077C81.5638 153.142 101.902 153.442 114.505 142.804C150.12 112.732 109.312 7.55946 83.9755 1.15191C82.5655 0.792604 78.7275 -0.176423 76.2341 1.82696C71.0569 5.9916 76.6261 19.0081 80.9595 37.9749C82.7941 46.0102 84.9282 57.3772 86.017 71.4662L86.0224 71.4717Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M64.498 62.1385C62.9465 54.9415 60.8343 46.9825 57.9326 38.4844C54.8023 29.3113 51.3182 21.178 47.883 14.1335",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M112.189 58.3834C109.739 51.4423 106.642 43.8099 102.695 35.7474C98.432 27.0425 93.9517 19.41 89.6564 12.8555",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M129.437 108.539C129.437 118.452 121.401 126.488 111.489 126.488C101.576 126.488 93.5398 118.452 93.5398 108.539V105.294C93.5398 95.3816 101.576 87.3456 111.489 87.3456C121.401 87.3456 129.437 95.3816 129.437 105.294V108.539Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M119.421 118.858C114.956 118.858 111.337 113.715 111.337 107.371C111.337 101.027 114.956 95.884 119.421 95.884C123.886 95.884 127.505 101.027 127.505 107.371C127.505 113.715 123.886 118.858 119.421 118.858Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M116.694 122.312L119.776 113.232L109.231 114.963L116.694 122.312Z",
    fill: "white"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M129.101 101.827C128.671 99.9709 127.326 95.338 123.085 91.7995C117.685 87.2919 109.219 85.9036 102.382 89.9158C93.987 94.8426 93.5569 104.669 93.5406 105.29C105.392 104.135 117.249 102.981 129.101 101.827Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M98.9171 108.089C98.9171 118.002 90.8811 126.038 80.9683 126.038C71.0555 126.038 63.0195 118.002 63.0195 108.089V104.845C63.0195 94.9319 71.0555 86.8959 80.9683 86.8959C90.8811 86.8959 98.9171 94.9319 98.9171 104.845V108.089Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9006 118.406C84.4357 118.406 80.8163 113.263 80.8163 106.919C80.8163 100.575 84.4357 95.4321 88.9006 95.4321C93.3654 95.4321 96.9849 100.575 96.9849 106.919C96.9849 113.263 93.3654 118.406 88.9006 118.406Z",
    fill: "#1E1E1E",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1692 121.874L89.2505 112.788L78.7055 114.519L86.1692 121.874Z",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M98.5803 101.383C98.1502 99.5263 96.8056 94.8935 92.5647 91.3549C87.1643 86.8473 78.6989 85.4591 71.8613 89.4713C63.4667 94.3981 63.0366 104.224 63.0203 104.845C74.8718 103.691 86.7288 102.537 98.5803 101.383Z",
    fill: "#5B5BD8",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M67.936 71.4532L83.6177 68.7839C86.3268 68.3228 88.8968 70.1451 89.3579 72.8542L89.6895 74.8024C90.1506 77.5114 88.3283 80.0814 85.6192 80.5425L69.9375 83.2118C67.2284 83.6729 64.6584 81.8506 64.1973 79.1415L63.8657 77.1934C63.4046 74.4843 65.2269 71.9143 67.936 71.4532Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M125.46 81.2637L109.778 78.5945C107.069 78.1333 105.247 75.5634 105.708 72.8543L106.04 70.9061C106.501 68.1971 109.071 66.3747 111.78 66.8359L127.461 69.5051C130.171 69.9662 131.993 72.5362 131.532 75.2453L131.2 77.1934C130.739 79.9025 128.169 81.7249 125.46 81.2637Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M101.895 130.356C102.015 135.011 98.536 138.462 95.2914 138.495C91.7202 138.533 87.8495 134.428 88.6879 129.268C93.092 129.627 97.4908 129.992 101.895 130.351V130.356Z",
    fill: "white",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M59.377 116.817C53.541 115.276 41.5752 111.171 32.3585 100.006C29.4787 96.5162 27.4317 93.0266 25.9673 89.9235C31.1445 83.3145 31.5038 76.7328 29.1139 74.8383C27.1269 73.265 22.7118 74.5062 18.6397 77.4024C10.7732 75.1649 3.88112 75.7256 1.42589 79.335C0.690952 80.4183 -1.28521 84.1856 5.71574 95.7105C11.2468 104.813 23.6046 120.78 52.5284 136.589",
    fill: "#5B5BD8"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M59.377 116.817C53.541 115.276 41.5752 111.171 32.3585 100.006C29.4787 96.5162 27.4317 93.0266 25.9673 89.9235C31.1445 83.3145 31.5038 76.7328 29.1139 74.8383C27.1269 73.265 22.7118 74.5062 18.6397 77.4024C10.7732 75.1649 3.88112 75.7256 1.42589 79.335C0.690952 80.4183 -1.28521 84.1856 5.71574 95.7105C11.2468 104.813 23.6046 120.78 52.5284 136.589",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2545 82.0023C9.72135 76.4549 8.82309 70.6898 10.3801 68.1529C11.0823 67.0097 12.2746 66.5415 13.3253 66.7211C16.0854 67.1893 18.9489 72.3121 19.8308 79.6124",
    fill: "#5B5BD8"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2545 82.0023C9.72135 76.4549 8.82309 70.6898 10.3801 68.1529C11.0823 67.0097 12.2746 66.5415 13.3253 66.7211C16.0854 67.1893 18.9489 72.3121 19.8308 79.6124",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04517 84.3943C6.54976 83.5885 6.02714 82.6141 5.55896 81.4763C4.94379 79.9683 4.58992 78.5855 4.37761 77.4478",
    fill: "#5B5BD8"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M7.04517 84.3943C6.54976 83.5885 6.02714 82.6141 5.55896 81.4763C4.94379 79.9683 4.58992 78.5855 4.37761 77.4478",
    stroke: "#1E1E1E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHero);
export default __webpack_public_path__ + "static/media/hero.988bff9be68ed922d6981be48772ffd6.svg";
export { ForwardRef as ReactComponent };